import { render, staticRenderFns } from "./KeyboardMagnetic.vue?vue&type=template&id=554861f2&scoped=true&"
import script from "./KeyboardMagnetic.vue?vue&type=script&lang=js&"
export * from "./KeyboardMagnetic.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardMagnetic.vue?vue&type=style&index=0&id=554861f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554861f2",
  null
  
)

export default component.exports